import { OP } from "../../constant";

// ------------- > AGENT_STAFF ACTIONS < ----------- //
// agent list
export function fetchAgentStaffRequest(token, data){
    return {
        type: OP.AGENT_STAFF_LIST_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function fetchAgentStaffReset(){
    return {
        type: OP.AGENT_STAFF_LIST_RESET,
    }
}

// add agent
export function addAgentStaffRequest(token, data) {
    return {
        type: OP.ADD_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function addAgentStaffReset() {
    return {
        type: OP.ADD_AGENT_STAFF_RESET
    }
}

// view agent
export function viewAgentStaffRequest(token, data) {
    return {
        type: OP.VIEW_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function viewAgentStaffReset() {
    return {
        type: OP.VIEW_AGENT_STAFF_RESET
    }
}

// edit agent
export function editAgentStaffRequest(token, data) {
    return {
        type: OP.EDIT_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function editAgentStaffReset() {
    return {
        type: OP.EDIT_AGENT_STAFF_RESET
    }
}

// deactivate agent
export function activateAgentStaffRequest(token, data) {
    return {
        type: OP.ACTIVATE_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function activateAgentStaffReset() {
    return {
        type: OP.ACTIVATE_AGENT_STAFF_RESET
    }
}

// deactivate agent
export function deactivateAgentStaffRequest(token, data) {
    return {
        type: OP.DEACTIVATE_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function deactivateAgentStaffReset() {
    return {
        type: OP.DEACTIVATE_AGENT_STAFF_RESET
    }
}

// approve agent
export function approveAgentStaffRequest(token, data) {
    return {
        type: OP.APPROVE_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function approveAgentStaffReset() {
    return {
        type: OP.APPROVE_AGENT_STAFF_RESET
    }
}

// reject agent
export function rejectAgentStaffRequest(token, data) {
    return {
        type: OP.REJECT_AGENT_STAFF_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function rejectAgentStaffReset() {
    return {
        type: OP.REJECT_AGENT_STAFF_RESET
    }
}

// reset agent password
export function resetAgentPasswordRequest(token, data) {
    return {
        type: OP.RESET_AGENT_PASSWORD_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function resetAgentPasswordReset() {
    return {
        type: OP.RESET_AGENT_PASSWORD_RESET
    }
}

// unblock agent 
export function unblockAgentRequest(token, data) {
    return {
        type: OP.UNBLOCK_AGENT_REQUEST,
        payload: {
            token,
            data
        }
    }
}

export function unblockAgentReset() {
    return {
        type: OP.UNBLOCK_AGENT_RESET
    }
}